/**
 * Unified glass/frosted-glass design tokens.
 */

export const GLASS_BLUR = 'blur(20px) saturate(180%)';

export const GLASS_BORDER_ALPHA = 0.12;
export const GLASS_BORDER_DARK = `1px solid rgba(255, 255, 255, ${GLASS_BORDER_ALPHA})`;
export const GLASS_BORDER_LIGHT = `1px solid rgba(0, 0, 0, ${GLASS_BORDER_ALPHA})`;

export const GLASS_SHADOW = '0 8px 24px rgba(0, 0, 0, 0.25)';
export const GLASS_SHADOW_ELEVATED = '0 12px 40px rgba(0, 0, 0, 0.35)';

export const GLASS_BG_DARK_ALPHA = 0.75;
export const GLASS_BG_DARK = `rgba(0, 0, 0, ${GLASS_BG_DARK_ALPHA})`;

export const GLASS_BG_LIGHT_ALPHA = 0.85;
export const GLASS_BG_LIGHT = `rgba(255, 255, 255, ${GLASS_BG_LIGHT_ALPHA})`;

export const GLASS_RADIUS = 16;

export const glassSurfaceDark = {
  backdropFilter: GLASS_BLUR,
  WebkitBackdropFilter: GLASS_BLUR,
  border: GLASS_BORDER_DARK,
  boxShadow: GLASS_SHADOW,
} as const;

export const glassSurfaceLight = {
  backdropFilter: GLASS_BLUR,
  WebkitBackdropFilter: GLASS_BLUR,
  border: GLASS_BORDER_LIGHT,
  boxShadow: GLASS_SHADOW,
} as const;

export function glassSurface(isDark: boolean) {
  return isDark ? glassSurfaceDark : glassSurfaceLight;
}

export function glassBackground(isDark: boolean) {
  return isDark ? GLASS_BG_DARK : GLASS_BG_LIGHT;
}

export function glassBorder(isDark: boolean) {
  return isDark ? GLASS_BORDER_DARK : GLASS_BORDER_LIGHT;
}
